import { isAxiosError } from "axios";

import type {
  ApiV1AccountLoginPostRequest,
  ApiV1AccountPasswordPutRequest,
  RegisterRequest,
  ResendActivationRequest,
  AuthApi,
} from "../generated";
import { createAPISlice } from "./createAPISlice";

export default function createAuthApis(authApi: AuthApi) {
  return createAPISlice(
    {
      loginWeb: async (params: ApiV1AccountLoginPostRequest) => {
        return await authApi.apiV1AccountWebLoginPost(params);
      },
      refreshWeb: async () => {
        return await authApi.apiV1AccountWebRefreshPost();
      },
      logoutWeb: async () => {
        return await authApi.apiV1AccountWebLogoutPost();
      },
      login: async (params: ApiV1AccountLoginPostRequest) => {
        return await authApi.apiV1AccountLoginPost(params);
      },
      register: async (params: RegisterRequest) => {
        return await authApi.apiV1AccountRegisterPost(params);
      },
      resetPassword: async (params: ApiV1AccountPasswordPutRequest) => {
        return await authApi.apiV1AccountPasswordPut(params);
      },
      resendVerificationEmail: async (params: ResendActivationRequest) => {
        return await authApi.apiV1AccountResendActivationPost(params);
      },
    },
    {
      resetPassword: (error) => {
        if (isAxiosError(error) && error.status === 422) {
          const emailError =
            error.response?.data?.context?.validation?.email?.[0];
          if (emailError) {
            return {
              fieldErrors: {
                email: emailError,
              },
            };
          }
        }
      },
    },
  );
}
